import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row, Table} from "react-bootstrap";
import axios from "axios";

import {InsuranceRateItemsView} from "./InsuranceRateItemsView";

export const MedicalServiceView = (props: { cookieEntityQr: string, type: string, name: string, category: string, postAction: any }) => {

    const [formData, setFormData] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [itemId, setItemId] = useState(null);
    const [sellingPrice, setSellingPrice] = useState(null);

    function fetchItem() {
        axios.get('/api/backend/inventory/item/fetch/' + props.cookieEntityQr + "?type=" + props.type + "&name=" + encodeURIComponent(props.name) + "&category=" + encodeURIComponent(props.category))
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setItemId(resp.data.id)
                setFormData(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    const handleSubmit = (e) => {
        if (itemId) {
            axios.post('/api/backend/inventory/item/update/' + itemId, {
                ...formData,
                type: "SERVICE",
                category: props.category ? props.category : (formData["category"] ? formData["category"] : "Medical Services"),
                entityQr: props.cookieEntityQr,
                taxable: formData["intraStateTaxPerc"] != null,
                expirable: false,
                stockQuantity: 1,
                sku: "none",
                unit: "BOX"
            })
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setSuccessMessage("* Data updated")
                    props.postAction()
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                    setErrorMessage("* Something went wrong!")
                })
        } else {
            axios.post('/api/backend/inventory/item/create', {
                ...formData,
                type: "SERVICE",
                category: props.category ? props.category : (formData["category"] ? formData["category"] : "Medical Services"),
                entityQr: props.cookieEntityQr,
                taxable: formData["intraStateTaxPerc"] != null,
                expirable: false,
                stockQuantity: 1,
                sku: "none",
                unit: "BOX"
            }).then(resp1 => {
                axios.post('/api/backend/inventory/item/batch/create', {
                    itemId: resp1.data.id,
                    sku: "none",
                    sellingPrice: sellingPrice
                })
                    .then(resp2 => {
                        console.log(JSON.stringify(resp2.data))
                        setSuccessMessage("* Data updated")
                        props.postAction()
                    })
                    .catch(err => {
                        console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                        setErrorMessage("* Something went wrong!")
                    })
            })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                    setErrorMessage("* Something went wrong!")
                })
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    useEffect(() => {
        setFormData({
            ...formData
        });
        if (props.name) {
            fetchItem();
        }
    }, [props.name])


    function getItemForm() {
        return <>
            <div className="row">

                {!props.category &&
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="category">
                            <Form.Label className="fs-7 text-secondary">Category<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Select className="form-select"
                                         value={formData['category']}
                                         name="category"
                                         onChange={e => handleChange(e)}
                            >
                                <option value="Medical Services">Medical Services</option>
                                <option value="Medical Procedures">Medical Procedures</option>
                                <option value="Others">Others</option>
                            </Form.Select>
                        </Form.Group>
                    </div>}
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label className="fs-7 text-secondary">Name<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={formData['name']} onChange={handleChange} name="name" type="text"
                                      placeholder="Enter name"/>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="intraStateTaxPerc">
                        <Form.Label className="fs-7 text-secondary">Tax %</Form.Label>
                        <Form.Control onChange={handleChange} value={formData['intraStateTaxPerc']}
                                      name="intraStateTaxPerc" type="tel"
                                      placeholder="Enter Tax %"/>
                    </Form.Group>
                </div>
                {!itemId && <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="sellingPrice">
                        <Form.Label className="fs-7 text-secondary">Cost (inclusive of taxes)<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control onChange={e => setSellingPrice(e.target.value)} name="sellingPrice"
                                      type="number"
                                      placeholder="Enter Price in ₹"/>
                    </Form.Group>
                </div>
                }
                {itemId && <InsuranceRateItemsView itemId={itemId} cookieEntityQr={props.cookieEntityQr}/>}

                <div className="pt-5">
                    <Button className="text-white" variant="info" type="submit" onClick={handleSubmit}>
                        Save
                    </Button>
                </div>
                {successMessage &&
                    <div className="text-success fs-5">{successMessage}</div>
                }
                {errorMessage &&
                    <div className="text-danger fs-5">{errorMessage}</div>
                }
            </div>
        </>;
    }


    return (
        <>
            {getItemForm()}
        </>
    );
};
